export default __webpack_public_path__ + "static/media/Astronaut.b6de94fd.svg";